(() => {
  const start = Date.parse('2026-10-19T17:11:52+02:00');
  const end = Date.parse('2026-10-26T00:00:00+01:00');
  const root = document.documentElement;
  // Preview is restricted to Shopify theme previews, never the published shop.
  const preview = root.dataset.arwCampaignPreview === 'true';
  function sync() {
    const now = Date.now();
    const active = root.dataset.arwFathersPreview !== 'true' && (preview || (now >= start && now < end));
    const changed = root.classList.contains('arw-opening-active') !== active;
    root.classList.toggle('arw-opening-active', active);
    window.arwOpeningCampaign = {active, start, end, preview};
    if (changed) document.dispatchEvent(new CustomEvent('arw:campaign-change'));
  }
  sync();
  setInterval(sync, 1000);
  document.addEventListener('visibilitychange', sync);
})();
